<div class="hidden md:flex flex-col project-filter-container">
  <div class="flex items-center gap-4 flex-wrap px-2">
    <span class="font-sans text-lg font-bold pl-1">Projects</span>
    <ng-container *ngTemplateOutlet="projectChips"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="projectsList"></ng-container>
</div>
<div class="md:hidden block project-filter-container">
  <p-accordion [value]="0">
    <p-accordion-panel [value]="0">
      <p-accordion-header>
        <ng-template #toggleicon let-active="active">
          @if (active) {
            <i class="fa-light fa-minus-circle"></i>
          } @else {
            <i class="fa-light fa-plus-circle"></i>
          }
        </ng-template>
        <div class="flex justify-between items-center pr-4 w-full">
          <span class="font-sans text-lg font-bold px-4">Projects</span>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <div class="flex px-3 pt-4">
          <ng-container *ngTemplateOutlet="projectChips"> </ng-container>
        </div>
        <ng-container *ngTemplateOutlet="projectsList"></ng-container>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>

<ng-template #projectsList>
  <p-tree
    #tree
    [value]="projects()"
    selectionMode="checkbox"
    class="w-full md:w-30rem"
    [selection]="selectedProjects()"
    [filter]="true"
    filterPlaceholder="Search Projects"
    (selectionChange)="onNodeSelect($event)"
    [propagateSelectionUp]="false"
    [propagateSelectionDown]="false"
    loadingMode="icon"
    [lazy]="true"
    loadingIcon="fa-light fa-circle-notch fa-spin">
    <ng-template let-node pTemplate="default">
      <div class="flex items-center gap-1">
        <span class="text-md text-black break-all">{{ node.label }}</span>
        <i class="fa-solid fa-circle text-[9px]" [ngStyle]="{ color: node.data.BrandColor }"></i>
      </div>
    </ng-template>
  </p-tree>
</ng-template>

<ng-template #projectChips>
  <ng-container *ngIf="selectedProjectsCount() > 0">
    <p-chip *ngIf="project().ID" label="{{ selectedProjectsCount() }} projects" class="mr-4" [removable]="true" (onRemove)="onToggleSelectAll()"></p-chip>
  </ng-container>
  <ng-container *ngIf="selectedProjectsCount() === 0">
    <a class="text-xs text-gray-400 underline cursor-pointer" (click)="onToggleSelectAll()" *ngIf="project().ID">
      <span *ngIf="!projectsSelected">Select All</span>
    </a>
  </ng-container>
</ng-template>
